<template>
  <div>
    <label class="form-label" for="payments-select">
      {{ $t('common.paymentTypes.title') }}
    </label>
    <TomSelect
      v-model="componentValue.payments"
      :options="{
        create: false,
        placeholder: $t('common.paymentTypes.select')
      }"
      class="w-full"
      multiple
    >
      <option
        v-for="paymentType in paymentTypes"
        :value="paymentType"
        :key="paymentType"
      >
        {{ $t('common.paymentTypes.' + paymentType.toLowerCase()) }}
      </option>
    </TomSelect>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  data() {
    return {
      paymentTypes: [
        'CASH',
        'CARD',
        'LOYALTY_POINTS',
        'GASTRO_VOUCHER',
        'GASTRO_CARD'
      ]
    }
  },

  props: {
    payments: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:payments'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.payments,
      set: value => emit('update:payments', value)
    })

    return {
      componentValue
    }
  }
})
</script>
